export default __webpack_public_path__ + "static/spiritual-christian-shrines-5-295e3707c78c58fb8628f86a132018f7.jpg";